import { Translation } from '@ps/web-shared-components';
import { createForm } from '@ps/web-shared-ui';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { lastValueFrom } from 'rxjs';

import Toggle from '@swf/components/Inputs/Toggle';
import { select } from '@swf/core/store';
import type { Article } from '@swf/help';

import {
  TXTCLI_No,
  TXTCLI_Yes,
  TXTWCL_Did_you_find_this_article_usef_ELL,
  TXTWCL_Thank_you_for_your_feedback_to_ELL,
  TXTWCL_We_did_goodX
} from './Feedback.messages.json';
import styles from './Feedback.scss';
import NegativeFeedback from './NegativeFeedback';
import useSendRequest from './hooks';
import type { FeedbackStates } from './types';
import { FeedbackType } from './types';

interface Props {
  article: Article;
}

const Form = createForm();

const Feedback: React.FC<Props> = ({ article = {} as Article }) => {
  const [submitted, setSubmitted] = useState<FeedbackStates>('');
  const [selected, setSelected] = useState<FeedbackStates>('');
  const locale = useSelector(select.locale.get);
  const { handleSubmit } = useSendRequest();

  useEffect(() => {
    setSelected('');
    setSubmitted('');
  }, [article.ref]);

  const handlePositiveFeedback = () => {
    setSelected(FeedbackType.Yes);
    lastValueFrom(
      handleSubmit({
        type: FeedbackType.Yes,
        locale,
        article,
        url: window.location.href
      })
    )
      .then(() => setSubmitted(FeedbackType.Yes))
      .catch(() => setSelected(''));
  };

  return submitted === FeedbackType.No ? (
    <h2 className={styles.feedbackTitle}>
      😎
      <Translation {...TXTWCL_Thank_you_for_your_feedback_to_ELL} />
    </h2>
  ) : (
    <>
      <h2 className={styles.feedbackTitle}>
        <Translation {...TXTWCL_Did_you_find_this_article_usef_ELL} />
      </h2>
      <br />
      <Form className={styles.feedbackForm} onSubmit={() => undefined}>
        <ul className={styles.feedbackRadio}>
          <li className={styles.feedbackRadioItem}>
            <Toggle
              id="useful_yes"
              name="useful_option"
              label={TXTCLI_Yes}
              type="radio"
              value="true"
              disabled={selected !== ''}
              checked={selected === FeedbackType.Yes}
              onChange={handlePositiveFeedback}
              className={styles.feedbackRadioLabel}
            />
          </li>
          <li className={styles.feedbackRadioItem}>
            <Toggle
              id="useful_no"
              name="useful_option"
              label={TXTCLI_No}
              type="radio"
              value="false"
              disabled={selected !== ''}
              checked={selected === FeedbackType.No}
              onChange={() => setSelected(FeedbackType.No)}
              className={styles.feedbackRadioLabel}
            />
          </li>
        </ul>
        {submitted === FeedbackType.Yes && (
          <p className={styles.furtherHelpText}>
            😊&nbsp;
            <Translation {...TXTWCL_We_did_goodX} />{' '}
            <Translation {...TXTWCL_Thank_you_for_your_feedback_to_ELL} />
          </p>
        )}
      </Form>
      {selected === FeedbackType.No && (
        <NegativeFeedback article={article} setSubmitted={setSubmitted} />
      )}
    </>
  );
};

export default Feedback;
